import { jsx } from "react/jsx-runtime";
import { ControllerProvider, useController } from "./controller-context.js";
import { HostProvider, useHost } from "./host-context.js";
function FormViewerContext({
  children,
  host,
  wfActions,
  wfConfig,
  wfResults
}) {
  return /* @__PURE__ */ jsx(HostProvider, { host, children: /* @__PURE__ */ jsx(
    ControllerProvider,
    {
      wfActions,
      wfConfig,
      wfResults,
      children
    }
  ) });
}
function useFormViewerContext() {
  const controller = useController();
  const host = useHost();
  return { controller, host };
}
export {
  FormViewerContext,
  useFormViewerContext
};
//# sourceMappingURL=form-viewer-context.js.map
